import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "@/components/ui/card";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Activity, UserCog, Shield, User } from "lucide-react";

const ROLE_META = {
  owner: { label: "Titolare", cls: "bg-dusty-50 text-dusty-700 border-dusty-200", icon: Shield },
  collaboratore: { label: "Collaboratore", cls: "bg-indigo-50 text-indigo-700 border-indigo-200", icon: UserCog },
  partner: { label: "Partner", cls: "bg-amber-50 text-amber-700 border-amber-200", icon: User },
};

const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);
  const [attori, setAttori] = useState([]);
  const [actor, setActor] = useState("all");

  const load = (aid) => {
    const params = aid && aid !== "all" ? { actor_id: aid } : {};
    api.get("/activity", { params }).then((r) => { setLogs(r.data.logs); setAttori(r.data.attori); }).catch(() => {});
  };
  useEffect(() => { load(actor); }, [actor]);

  return (
    <div className="space-y-6 animate-fade-up">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold text-slate-900 flex items-center gap-2"><Activity className="h-7 w-7 text-dusty-600" /> Attività dello staff</h1>
          <p className="text-sm text-slate-500 mt-1">Registro delle operazioni: chi ha creato, modificato o eliminato dati nel gestionale.</p>
        </div>
        <div className="w-full sm:w-72">
          <Select value={actor} onValueChange={setActor}>
            <SelectTrigger data-testid="activity-actor-filter" className="bg-white"><SelectValue placeholder="Tutti gli operatori" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutti gli operatori</SelectItem>
              {attori.map((a) => (
                <SelectItem key={a.actor_id} value={a.actor_id}>{a.nome} · {ROLE_META[a.role]?.label || a.role} ({a.count})</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <Card className="border-slate-200 shadow-sm">
        <div className="divide-y divide-slate-100">
          {logs.map((l) => {
            const meta = ROLE_META[l.actor_role] || ROLE_META.collaboratore;
            const Icon = meta.icon;
            return (
              <div key={l.id} className="flex items-center gap-3 px-4 py-3 hover:bg-slate-50" data-testid={`activity-row-${l.id}`}>
                <div className={`h-9 w-9 rounded-lg border flex items-center justify-center shrink-0 ${meta.cls}`}><Icon className="h-4 w-4" /></div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm text-slate-800">
                    <span className="font-semibold">{l.actor_nome}</span>
                    <span className={`ml-2 inline-flex text-[11px] px-1.5 py-0.5 rounded-full border ${meta.cls}`}>{meta.label}</span>
                  </div>
                  <div className="text-sm text-slate-500 truncate">{l.descrizione}</div>
                </div>
                <div className="text-xs text-slate-400 shrink-0 whitespace-nowrap">{fmtDateTime(l.created_at)}</div>
              </div>
            );
          })}
          {logs.length === 0 && <div className="text-slate-400 py-16 text-center">Nessuna attività registrata ancora.</div>}
        </div>
      </Card>
    </div>
  );
}
